import axios from "axios"; // API
import { putAccount } from "../api/account";

let interceptor: number;

//axios使用時にidTokenを設定する関数
export async function setTokenInterceptor(
  idToken: string,
  onPutAccount: boolean
) {
  interceptor = axios.interceptors.request.use(async (req) => {
    req.headers.Authorization = `Bearer ${idToken}`;
    return req;
  });
  if (onPutAccount) {
    putAccount({
      status: "editing",
      editType: "text",
      tableId: "1",
      id: 1,
      key: "last_login_date",
      name: "",
      value: "",
      editValue: "",
      editPhoneNumber: "",
      editName: "",
      editCustomerName: "",
      tel_flg: 0,
      name_flg: 0,
      company_name_flg: 0,
      half_width_number_flg: 0,
      customerList: [],
      payment_method_id: "",
      service_id: "",
      customer_picture: null,
    });
  }
}

//axios使用時にidTokenの設定を削除する関数
export function resetTokenInterceptor() {
  axios.interceptors.request.eject(interceptor);
}
